import React from 'react';
import { Field } from 'formik';
import Input, { Textarea } from '../Input';
import Select from '../Select';

/**
 * FormikInput — Connects Stride's modular Input component directly to Formik state.
 * Automatically wires name, value, onChange, onBlur, and validation error messages.
 */
export const FormikInput = ({ name, id, onChange, onBlur, error, ...props }) => {
    return (
        <Field name={name}>
            {({ field, meta, form }) => (
                <Input
                    id={id || name}
                    {...field}
                    {...props}
                    error={(meta.touched && meta.error) ? meta.error : error}
                    onChange={(e) => {
                        field.onChange(e);
                        if (onChange) onChange(e, form);
                    }}
                    onBlur={(e) => {
                        field.onBlur(e);
                        if (onBlur) onBlur(e, form);
                    }}
                />
            )}
        </Field>
    );
};

/**
 * FormikTextarea — Connects Stride's modular Textarea component directly to Formik state.
 */
export const FormikTextarea = ({ name, id, onChange, onBlur, error, ...props }) => {
    return (
        <Field name={name}>
            {({ field, meta, form }) => (
                <Textarea
                    id={id || name}
                    {...field}
                    {...props}
                    error={(meta.touched && meta.error) ? meta.error : error}
                    onChange={(e) => {
                        field.onChange(e);
                        if (onChange) onChange(e, form);
                    }}
                    onBlur={(e) => {
                        field.onBlur(e);
                        if (onBlur) onBlur(e, form);
                    }}
                />
            )}
        </Field>
    );
};

/**
 * FormikSelect — Connects Stride's modular Select component directly to Formik state.
 */
export const FormikSelect = ({ name, id, onChange, error, ...props }) => {
    return (
        <Field name={name}>
            {({ field, meta, form }) => (
                <Select
                    id={id || name}
                    name={name}
                    value={field.value}
                    {...props}
                    error={(meta.touched && meta.error) ? meta.error : error}
                    onChange={(e) => {
                        const val = e?.target ? e.target.value : e;
                        form.setFieldValue(name, val);
                        form.setFieldTouched(name, true, false);
                        if (onChange) onChange(e, form);
                    }}
                />
            )}
        </Field>
    );
};

export default FormikInput;

